import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';

const { recommend, chat } = window.localeBundle ? window.localeBundle['smarthelp/contactOption'] : {};

class ContactOption extends Component {
  renderRecommended() {
    if (!this.props.recommended) {
      return null;
    }
    return (
      <p className="icon-recommended">{recommend}</p>
    );
  }
  renderTooltip() {
    if (this.props.toolTip) {
      return (<div className="chat-tip">
        <a className="tooltip-chat" role="link" data-tip={chat.tooltipContent}>{chat.toolTip}</a>
        <ReactTooltip className="tooltip_passcode" multiline="true" place="bottom" float="solid" />
      </div>);
    }
    return null;
  }
  render() {
    return (
      <div className="contact-panel" id={this.props.id}>
        <button className={this.props.iconClass} onClick={this.props.clickAction} aria-label={`${this.props.text} icon`} />
        <div className="channel-content">
          <button onClick={this.props.clickAction} role="link" className={this.props.contactLinkCSS} aria-label={`${this.props.text} link`}>{this.props.text}</button>
          <div className={this.props.supportMessageCSS}>
            {this.props.message}
          </div>
          {this.renderTooltip()}
          {this.renderRecommended()}
        </div>
      </div>
    );
  }
}
ContactOption.propTypes = {
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  contactLinkCSS: PropTypes.string.isRequired,
  clickAction: PropTypes.func.isRequired,
  iconClass: PropTypes.string.isRequired,
  supportMessageCSS: PropTypes.string.isRequired,
  recommended: PropTypes.bool,
  toolTip: PropTypes.bool,
};

ContactOption.defaultProps = {
  recommended: false,
  toolTip: false,
};

export default ContactOption;



// WEBPACK FOOTER //
// ./contactUs/components/ContactOption.js